import { cn } from '@spiaggeit/spit-ui'
import { Icon } from '@/assets/icons'

interface Props {
  label: string
  index: number
  activeStepIndex: number
}

export const Step = (props: Props) => {
  const { index, label, activeStepIndex } = props
  const isActive = index === activeStepIndex
  const isDone = index < activeStepIndex

  return (
    <div className="relative">
      <div
        className={cn('size-5 rounded-circle border', {
          'progress-step--active border-brand bg-brand shadow-[inset_0_0_0_4.5px_var(--white)]':
            isActive,
          'progress-step--done border-brand bg-brand p-px text-white': isDone,
        })}
      >
        {isDone ? <Icon className="size-4" name="ApproveTick" /> : null}
      </div>

      <div
        className={cn(
          'absolute left-1/2 -translate-x-1/2 text-nowrap p-1 text-xs text-secondary',
          { 'font-bold': isActive }
        )}
      >
        {label}
      </div>
    </div>
  )
}
